import { Plugin } from "@nuxt/types";
import { initializeI18n } from "../../shared/accessors/i18n";

const accessor: Plugin = ({ i18n }) => {
  initializeI18n(i18n);
};

export default accessor;
